var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timer)?_c('div',[_c('div',{staticClass:"text-h5 text-bold text-grey-8"},[_vm._v(_vm._s(_vm.display.hours + ' : ' + _vm.display.mins + ' : ' + _vm.display.seconds))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }